import React, { useState, useEffect } from "react";
import { Grid, makeStyles, withStyles, Card } from '@material-ui/core';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ObligatoryIcon from "../../icons/ObligatoryIcon";
import BasketIcon from '../../icons/BasketIcon';
import SolutionsIcon from '../SolutionsIcon';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import axios from 'axios';
import config from '../../other/config';
const {serverAPI} = config;

export default function CloudServiceCard(props) {
	const classes = useStyles();
	const lang = localStorage.getItem('language') || 'Ru';
	let [allCheckBox, setAllCheckBox] = useState(false);
	let [checkAll, setCheckAll] = useState(false);
	let { cardArr } = props;

	function renderAction(card) {
		let apps = card.AppsIDsNeeded ? card.AppsIDsNeeded.trim().split(/\s*,\s*/).map(Number) : ''
		let basketApp = JSON.parse(localStorage.getItem('cartApp')) || [];
		let bA1 = basketApp.filter(item => apps.includes(item))

			if (bA1.length !== apps.length) {
				return (
					<CustomTooltip placement="top" title={translate.Words[`AddTobasket${lang}`]}>
						<IconButton className={classes.icon} onClick={() => props.setBasketSolution(card)} style={{ backgroundColor: '' }}>
							<BasketIcon fill={'#BCBBD0'} />
						</IconButton>
					</CustomTooltip>
				)
			}
	}

	useEffect(() => {
		let basketSolutions = JSON.parse(localStorage.getItem('cartSolutions')) || []
		let isAll = cardArr.every(el => basketSolutions.includes(el.ID))
		setAllCheckBox(isAll)
	}, [cardArr, checkAll]);

	return (
		cardArr.map((el, id) =>
			<Grid item>
				<Card className={classes.root}>
					<CardHeader
						className={classes.CardHeaderRoot}
						avatar={
							<Avatar aria-label="recipe" className={classes.avatar} src={`${serverAPI}/9cade9b5a064f0d99ee9501f09588081/pict/Group%20597.svg`} />
						}
					/>

					<CardContent className={classes.CardContentRoot}>
						<a href={`/solutions/${el.url}/overview`} style={{ textDecoration: 'none', maxWidth: '100%' }} rel="noopener noreferrer" target="_blank">
							<Grid container className={classes.InfoCntr}>
								<Typography className={classes.Body2medium}>
									{el.Title}
								</Typography>

								<Typography className={classes.Caption1} style={{ marginTop: 8 }}>
									{el.BriefDescription}
								</Typography>
							</Grid>
						</a>

						<Grid container className={classes.container} style={{ padding: '16px 0' }}>
							<Grid item style={{ marginBottom: 6 }}>
								<Typography className={classes.Body2medium}>{translate.Words[`Applications_${lang}`]}</Typography>
							</Grid>

							<Grid
								container
								direction="row"
								alignItems="center"
								className={classes.priceContainer}
								style={{ justifyContent: "space-between" }}
							>
								<Grid item container direction="row" style={{ width: 223 }}>
									<Grid item style={{ width: 24 }}>
										<ObligatoryIcon fill={'#EB505E'} />
									</Grid>

									<Grid item style={{ width: 199 }}>
										<Typography className={classes.Caption1}>{translate.Words[`LicensingRequired${lang}`]}</Typography>
									</Grid>
								</Grid>

								<Grid item>
									<Typography className={classes.Caption1} style={{ color: '#24262A' }}>{el.AppsIDsNeededCount}</Typography>
								</Grid>
							</Grid>
						</Grid>
					</CardContent>

					<CardActions disableSpacing className={classes.CardActionsRoot}>
						{renderAction(cardArr[id])}
					</CardActions>
				</Card >
			</Grid>
		)
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
	root: {
		width: 312,
		height: 418,
		borderRadius: 16,
		boxShadow: 'none',
	},

	CardHeaderRoot: {
		padding: theme.spacing(3),
		paddingBottom: 15
	},

	CardContentRoot: {
		padding: '0 24px',
		height: 228
	},

	InfoCntr: {
		height: 126,
		overflow: 'hidden'
	},

	CardActionsRoot: {
		padding: '16px 24px 0'
	},

	icon: {
		backgroundColor: '#F6F6FB',
		marginLeft: 'auto',
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
	},

	avatar: {
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15,
		backgroundColor: '#EBEEFF',
	},

	Body2medium: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '14px',
		lineHeight: '18px',
		color: '#000000'
	},

	Caption1: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#8987A2'
	},

	priceContainer: {
		padding: '4px 0'
	}
}));